import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "pageheader_title" }, " 某某驾考 ", -1)

import { reactive, ref } from "vue";
import { useRouter } from "vue-router"
import { NInput, NButton, NPageHeader, NAvatar, NConfigProvider, GlobalThemeOverrides,NProgress } from "naive-ui";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();

// 组件样式
const themeOverrides: GlobalThemeOverrides = {
  // common: {
  //   primaryColor: '#4970BD',
  //   borderColor: "#E6E6E6",
  //   hoverColor: "#4970BD",
  //   primaryColorHover: "#4970BD"
  // },
}

// let testData = [
//   {
//     id: 0,
//     name: "精选试题一"
//   },
//   {
//     id: 0,
//     name: "精选试题二"
//   },
//   {
//     id: 0,
//     name: "精选试题三"
//   },
//   {
//     id: 0,
//     name: "精选试题四"
//   },
//   {
//     id: 0,
//     name: "精选试题五"
//   },
//   {
//     id: 0,
//     name: "精选试题六"
//   },
//   {
//     id: 0,
//     name: "精选试题七"
//   },
//   {
//     id: 0,
//     name: "常识试题一"
//   },
//   {
//     id: 0,
//     name: "常识试题二"
//   },
//   {
//     id: 0,
//     name: "常识试题三"
//   },
//   {
//     id: 0,
//     name: "常识试题四"
//   },
//   {
//     id: 0,
//     name: "常识试题五"
//   },
//   {
//     id: 0,
//     name: "常识试题六"
//   },
// ]

// const percentage = ref(20);
// const topicList = reactive(testData);

let login = localStorage.getItem("login");
if(login != "1"){
  router.replace("/login")
}

const goHome = () => {
  router.push("/")
}


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_unref(NConfigProvider), { "theme-overrides": themeOverrides }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", { class: "pageheader" }, [
          _createElementVNode("div", {
            class: "pageheader_logo",
            onClick: goHome
          }, _hoisted_3),
          _hoisted_4
        ]),
        _createVNode(_component_router_view)
      ])
    ]),
    _: 1
  }))
}
}

})